import classNames from 'classnames'

import { MaxButton } from '~/components/MaxButton'
import { Progress } from '~/components/Progress'
import { SymbiosisInput } from '~/components/SymbiosisInput'
import { MAX_VESIS_WEEKS, WEEKS_IN_YEAR } from '~/lib/constants'

import styles from './AdvanceMode.pcss'

interface Props {
	availableWeeks: number
	className?: string
	disabled?: boolean
	value: number
	onChange: (weeks: number) => void
}

export function AdvanceMode({
	availableWeeks,
	className,
	disabled,
	value,
	onChange,
}: Props) {
	const canChange = availableWeeks > 1
	const isIncrease = availableWeeks !== MAX_VESIS_WEEKS

	let increase: number | undefined
	let progress: number
	if (isIncrease) {
		progress = MAX_VESIS_WEEKS - availableWeeks
		increase = value
	} else {
		progress = value
	}

	const onWeeksChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
		if (!target.value) {
			onChange(0)
			return
		}

		if (target.value.includes('.') || target.value.includes(',')) {
			return
		}

		const weeks = Number.parseInt(target.value)
		if (Number.isNaN(weeks) || weeks < 0) {
			return
		}

		if (weeks >= availableWeeks) {
			onChange(availableWeeks)
			return
		}

		onChange(weeks)
	}

	const inputValue = isIncrease ? increase : progress

	return (
		<div className={classNames(styles.container, className)}>
			<SymbiosisInput
				className={styles.input}
				disabled={disabled || !canChange}
				label="Weeks Prolongation"
				placeholder="Enter number of Weeks"
				step={1}
				value={inputValue ? inputValue.toString() : ''}
				endAdornment={
					<MaxButton
						disabled={disabled || !canChange}
						onClick={() => {
							onChange(availableWeeks)
						}}
					/>
				}
				onChange={onWeeksChange}
			/>
			<Progress
				max={MAX_VESIS_WEEKS}
				increase={increase}
				value={progress}
				step={WEEKS_IN_YEAR}
			/>
		</div>
	)
}
